import { useQuery } from "@tanstack/react-query";
import type { UUID } from "@/lib/types";

/**
 * Live viewers of a board — the user-ids currently connected, aggregated
 * server-side (Redis) and pushed over the board WebSocket as `presence.update`.
 * useBoard writes them into this query cache; this hook just reads them. No
 * fetch of its own (the WS is the source).
 */
export function useBoardPresence(boardId: UUID | undefined): string[] {
  const { data } = useQuery<string[]>({
    queryKey: ["boards", boardId, "presence"],
    queryFn: () => [],
    enabled: Boolean(boardId),
    staleTime: Infinity,
    initialData: [],
  });
  return data ?? [];
}
